import { useState } from 'react'
import { Input } from '../ui'
import { SOURCE_GROUPS, listedSource } from '../../lib/bottleSources'

const OTHER = '__other__'

// FOS-SOURCE-PICKER-KEYBOARD-001: pick a store or website from one shared list (a
// native picker on iPhone, so no keyboard), or choose Other to type a name that is
// not listed. A saved name that is not on the list reopens as Other with its text.
export default function SourceNamePicker({ value, onChange, label = 'Store or website' }) {
  const listed = listedSource(value)
  const [typing, setTyping] = useState(false)
  // Reopening a saved unlisted name shows it without raising the keyboard; the field is
  // focused only when the person picks Other now.
  const [justChoseOther, setJustChoseOther] = useState(false)
  // A saved name that is not listed always shows as Other with its text, even when it
  // arrives after the first render (a sheet that loads its values in an effect).
  const showTyping = typing || (Boolean(value) && !listed)
  const selected = showTyping ? OTHER : (listed || '')
  const choose = event => {
    const next = event.target.value
    if (next === OTHER) { setTyping(true); setJustChoseOther(true); onChange(''); return }
    setTyping(false); setJustChoseOther(false)
    onChange(next)
  }
  return <div className="flex flex-col gap-3" data-source-picker>
    <div className="flex flex-col gap-1">
      <label className="text-xs text-cream/60 font-medium uppercase tracking-wide">{label}</label>
      <select aria-label={label} value={selected} onChange={choose}
        className="min-h-11 w-full bg-charcoal-600 border border-white/10 rounded-lg px-3 py-2 text-cream focus:outline-none focus:border-gold transition-colors">
        <option value="">Choose…</option>
        {SOURCE_GROUPS.map(group => <optgroup key={group.label} label={group.label}>
          {group.names.map(name => <option key={name} value={name}>{name}</option>)}
        </optgroup>)}
        <option value={OTHER}>Other (type it)</option>
      </select>
    </div>
    {showTyping && <Input aria-label="Name it" label="Name it" placeholder="Store or website name" autoFocus={justChoseOther}
      value={value || ''} onChange={event => onChange(event.target.value)} />}
  </div>
}
